import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const BadgeNew = ({ size, className }) => {
  const { t } = useI18n();
  const { sportsBookAdvFilter = {} } = useOtherSettings();
  const { isShowNewLabel = true } = sportsBookAdvFilter;

  if (!isShowNewLabel) {
    return null;
  }

  const fontSize = size === '2xs' ? '2xs' : 'xs';

  return (
    <Box align="center" className={clsx(styles.root, className)}>
      <AText
        breed="BU"
        size={fontSize}
        color="txt_color_4"
        className={styles.text}
      >
        {t('sportsbook.sportsMenu.advFilter.badge.new')}
      </AText>
    </Box>
  );
};
